import React from 'react';
import { motion } from 'framer-motion';
export function Banner() {
  return <motion.section className="relative w-full overflow-hidden" initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 1
  }} data-id="element-11">
      <img src="https://cdn.magicpatterns.com/uploads/kckqgzAW7demQkneaB2oFu/ChatGPT_Image_May_5,_2026,_05_25_12_PM.png" alt="Executive team engaged in a strategic discussion around a whiteboard" className="w-full h-32 md:h-40 lg:h-48 object-cover object-center" data-id="element-12" />
      {/* Tonal overlay to integrate with the navy theme */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy/30 via-transparent to-navy/40 pointer-events-none" data-id="element-13" />
      {/* Edge fades for soft integration with adjacent sections */}
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy/40 to-transparent pointer-events-none" data-id="element-14" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy/40 to-transparent pointer-events-none" data-id="element-15" />
    </motion.section>;
}